import $RefParser from '@apidevtools/json-schema-ref-parser'
import { defaultsAjv } from './JsonForm'
import type { ErrorObject } from '@jsonforms/core/node_modules/ajv/lib/ajv'

export const defaultRefResolver = async (schema: any) => {
  return await $RefParser.dereference(schema)
}

export const parseErrorsAsString = (errors: ErrorObject[]) => {
  return defaultsAjv.errorsText(errors, { dataVar: '', separator: ' | ' })
}

export const stripNullValues = (value: any): any => {
  if (Array.isArray(value)) {
    return value.map(stripNullValues)
  }
  if (value !== null && typeof value === 'object') {
    return Object.entries(value).reduce<Record<string, any>>((acc, [key, val]) => {
      if (val !== null) {
        acc[key] = stripNullValues(val)
      }
      return acc
    }, {})
  }
  return value
}
